import React from 'react';
import { CompModel } from '../types/compensation';
import { formatDkk, formatMillions, formatPercent } from '../utils/format';
interface ThemeTriadProps {
  model: CompModel;
}
export function ThemeTriad({
  model
}: ThemeTriadProps) {
  const items = [{
    key: 'security',
    title: 'SECURITY',
    lever: 'Fixed salary',
    value: `${formatDkk(model.fixedMonthly)}`,
    unit: '/month',
    sub: `${formatDkk(model.fixedAnnual)} guaranteed per year`,
    accent: '#7FA3C4'
  }, {
    key: 'performance',
    title: 'PERFORMANCE',
    lever: 'Sales commission',
    value: formatMillions(model.commissionOpportunity),
    unit: 'opportunity',
    sub: `${formatPercent(model.existingRate)} existing · ${formatPercent(model.newBusinessRate)} new business`,
    accent: '#E2A03F'
  }, {
    key: 'ownership',
    title: 'OWNERSHIP',
    lever: 'Warrants',
    value: formatPercent(model.ownershipPercent, 2),
    unit: 'indicative',
    sub: `${formatDkk(model.equityValue)} allocation value`,
    accent: '#5FB39B'
  }];
  return <div className="grid grid-cols-1 gap-px overflow-hidden rounded-card border border-line bg-line md:grid-cols-3" data-id="element-218" data-mp="2lwnlbnot8dvc">
      {items.map(item => <div key={item.key} className="bg-ink-900 p-6 lg:p-7" data-id="element-219" data-mp="2zv3x3t1j4ukc">
          <div className="flex items-center gap-2.5" data-id="element-220" data-mp="2uywt45sp1t51">
            <span className="h-2 w-2 rounded-full" style={{
          backgroundColor: item.accent
        }} aria-hidden="true" data-id="element-221" data-mp="278j6wvwsioid" />
            <h3 className="text-[13px] font-semibold uppercase tracking-[0.22em]" style={{
          color: item.accent
        }} data-id="element-222" data-mp="227mx61prc851">
              {item.title}
            </h3>
          </div>
          <p className="mt-1 text-sm text-paper-dim" data-id="element-223" data-mp="1oibbz138v4d9">{item.lever}</p>
          <p className="tnum mt-6 text-[30px] font-semibold leading-none tracking-tightest text-paper lg:text-[34px]" data-id="element-224" data-mp="1oggphicbr472">
            {item.value}
          </p>
          <p className="mt-1.5 text-xs uppercase tracking-[0.14em] text-paper-dim" data-id="element-225" data-mp="3jm9bqcvz2udg">
            {item.unit}
          </p>
          <p className="tnum mt-5 border-t border-line-soft pt-4 text-sm text-paper-muted" data-id="element-226" data-mp="3oj9h0lkzzt3i">
            {item.sub}
          </p>
        </div>)}
    </div>;
}